const formStatus = ({ hasFailed, isComplete, isPending }) => ({
    submitFailed: hasFailed,
    submitting: isPending,
    submitSucceeded: isComplete,
});

export default formStatus;
